module.exports = __webpack_public_path__ + "static/media/back1.2e132e4f.jpg";